<template>
    <div id="content_root">
      <div id="row1">
        <div class="circle deep" v-if="sleepModel.type==4"></div>
        <div class="circle awake" v-else-if="sleepModel.type==6"></div>
        <div class="circle rem" v-else-if="sleepModel.type==7"></div>
        <div class="circle light" v-else></div>
        <div id="content1">{{ sleepModel.name }}</div>
        <div id="content2">{{ $t("message")["Sleep.benchmark"] }}<img src="../../assets/right_normal_click.png" class="img_show"/></div>
      </div>
      <div id="row2">
        <div id="content3">
          <div class="value">{{ Math.floor(sleepModel.time/60) }}</div>
          <div class="unit">{{ $t("message")["Sleep.hour"] }}</div>
          <div class="value">{{ sleepModel.time%60 }}</div>
          <div class="unit">{{ $t("message")["Sleep.minute"] }}</div>
        </div>
        <div id="content4">{{ $t("message")["Sleep.value.low"] }}</div>
      </div>
      <div id="spliter"></div>
    </div>
</template>

<script>
export default {
  name: "SleepListItemView",
  props: ["sleepModel"],
  data() {
    return {
      showDetail: false
    }
  },
  methods: {
   show: function() {
    this.showDetail = !this.showDetail;
   }
  }
};
</script>

<style scoped>
#content_root {
  height: 60px;
}

#row1 {
  display: flex;
  align-items: center;
  margin-top: 3px;
}

#row2 {
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  margin-left: 20px;
}

.deep {
  background-color: #427FF7;
}

.light{
  background-color: #93C0FA;
}

.awake {
  background-color: #FADEAF;
}

.rem {
  background-color: #9899F5;
}

#content1 {
  color:#707070;
  font-size:12px;
  margin-left: 2px;
}

#content2 {
  color:#707070;
  font-size:12px;
  margin-left: auto;
  margin-right: 20px;
}

#content3 {
  margin-left: 32px;
  display: flex;
  align-items: center;
}

#content4 {
  color:#707070;
  font-size:14px;
  margin-left: auto;
  margin-right: 20px;
}

#spliter {
  height: 1px;
  width: calc(100% - 50px);;
  background-color: #EFEFEF;
  margin-top: 6px;
  margin-left: 25px;
  margin-right: 25px;
}


.img_show {
  height: 10px;
  width: 10px;
}

.value {
  color:#292929;
  font-size:14px;
  font-weight: bold;
}

.unit {
  color: #727272;
  font-size: 12px;
}
</style>
